import * as React from "react";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="right" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#F4F6F6",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "none",
    fontSize: theme.typography.pxToRem(12),
  },
}));

export default function CustomizedTooltips() {
  return (
    <div>
      <HtmlTooltip
        title={
          <React.Fragment>
            <Typography color="#212F3C" fontSize={"13px"}>
              Note
            </Typography>
            <Typography fontSize={"12px"} color={"#A6ACAF "}>
              After 10mins cancelation charge will be applied
            </Typography>
          </React.Fragment>
        }
      >
        <InfoIcon
          sx={{
            marginLeft: "5px",
            width: "19px",
            height: "19px",
            marginTop: "1px",
            color: "#A2A7AE",
            cursor: "pointer",
          }}
        />
      </HtmlTooltip>
    </div>
  );
}
